import React from 'react';
import { withRouter, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { NewspaperOutline, Add } from 'react-ionicons';
import SearchField from '../../../Common/SearchField'
import * as tableActions from '../../../../store/actions/table';
import EventTile from '../../../Common/EventTile';
import placeholder2 from '../../../../assets/images/placeholder1.png';
import EventModal from '../../../Common/EventModal';
import * as ENUMS from '../../../../utils/enums';
import BaseFilterPage from '../../BaseFilterPage'
import SchoolModal from "../../../Common/SchoolModal";
import PageLoader from "../../../Common/PageLoader";

class SchoolEvents extends BaseFilterPage {

  constructor(props) {
    super(props);
    this.state.items = [];
    this.state.showModal = false;
    this.state.ev = {};
  }

  componentDidUpdate(props, state) {
    if (
      (this.props.table.data.length !== this.state.items.length ||
        this.props.table.updateCount > props.table.updateCount ||
        this.props.table.data.length !== this.state.items.length) &&
      this.props.table.view === 'events'
    ) {
      this.setState({ items: this.props.table.data });
    } else {
      super.componentDidUpdate(props, state);
    }
  }

  fetchData(inputText) {
    let eventQuery = {};
    if (inputText) {
      // Add search text to query for event name field. regex gives us a substring match, "i" option for case insensitive
      eventQuery.name = { "$regex": inputText, "$options": "i" };
    }
    // Load all events
    this.props.getEventsWithEntriesBySchool(this.props.match.params.id, eventQuery, this.props.auth.token._id);
  }

  render() {
    let destination = this.props.match?.params?.destination;
    let teams = destination && destination.toLowerCase() === ENUMS.APP_CATEGORIES.TEAMS;
    let header = 'Select an Event to View Entries';
    return (
      <div className={'page-container'}>
        <PageLoader loaded={!this.props.table.tableLoading}>
            <SchoolModal show={this.state.showModal} data={this.state.ev} source="schools" hideModal={() => this.setState({showModal: false})} />
            <div className={'page-header'}>
                <Row>
                    <Col>
                    <h1>
                        <NewspaperOutline /> {header}
                        <SearchField onBlurValue={this.handleInputBlur} />
                    </h1>
                    </Col>
                </Row>
            </div>

            <div className={'section'}>
                <div className={'tile-grid'}>
                    <Row>
                    {this.props.table.data.length > 0 ? (
                        this.props.table.data.map((d, i) => {
                        return (
                            <EventTile
                            {...d}
                            data={d}
                            key={i}
                            placeholder={placeholder2}
                            viewType='schools'
                            onClick={e => {
                                                e.preventDefault();
                                                this.setState({showModal: true, ev: d});
                                            }}
                            />
                        );
                        })
                    ) : (
                        <h4 className={'no-data'}>No Events Found</h4>
                    )}
                    </Row>
                </div>
            </div>
        </PageLoader>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  table: state.table,
  user: state.user
});

const mapDispatchToProps = (dispatch) => ({
  getEventsWithEntriesBySchool: (schoolId, query, token) => {
    dispatch(tableActions.getEventsWithEntriesBySchool(schoolId, query, token));
  }
});

const Connected = withRouter(connect(mapStateToProps, mapDispatchToProps)(SchoolEvents));

class SchoolEventsContainer extends React.Component {
  render() {
    return (
      <div>
        <Connected {...this.props} />
      </div>
    );
  }
}

export default SchoolEventsContainer;
